import { render, staticRenderFns } from "./DiagnosisRecord.vue?vue&type=template&id=8eebf628&scoped=true"
import script from "./DiagnosisRecord.vue?vue&type=script&lang=js"
export * from "./DiagnosisRecord.vue?vue&type=script&lang=js"
import style0 from "./DiagnosisRecord.vue?vue&type=style&index=0&id=8eebf628&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eebf628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eebf628')) {
      api.createRecord('8eebf628', component.options)
    } else {
      api.reload('8eebf628', component.options)
    }
    module.hot.accept("./DiagnosisRecord.vue?vue&type=template&id=8eebf628&scoped=true", function () {
      api.rerender('8eebf628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/diagnosisRecord/DiagnosisRecord.vue"
export default component.exports